import Image from 'next/image';
import styled from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { ColTypes } from '@/constants/common';
import { flexCenterAligned } from '@/styles/common';
import { buildResponsiveGridMediaQueries } from '@/utils/helpers/getCSSGrid';

export const AvatarWrapper = styled.div<{
  $sizes: ColTypes;
  $withImage?: boolean;
}>`
  ${flexCenterAligned}
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
  background-color: ${({ $withImage }) => !$withImage && 'var(--bg-tertiary)'};
  position: relative;
  ${({ $sizes }) =>
    buildResponsiveGridMediaQueries($sizes, ['width', 'height'])}
`;

export const AvatarImage = styled(Image)`
  object-fit: cover;
`;

export const AvatarName = styled(Typography).attrs({
  htmlTag: 'p'
})<{
  $sizes: ColTypes;
}>`
  ${({ $sizes }) => buildResponsiveGridMediaQueries($sizes, ['font-size'])}
  font-weight: 700;
  color: var(--title-snackbar);
`;
